module.exports = __webpack_public_path__ + "img/hk_1.3078ff45.png";